<template>
  <div class="w-full bg-white border">
    <div class="pb-6">
      <div class="bg-primary flex rounded-t-md pl-4">
        <feather-icon
          icon="ListIcon"
          class="cursor-pointer my-auto text-white"
        ></feather-icon>
        <p class="text-white font-bold text-xl py-4 pl-4">Contents</p>
      </div>
      <div class="rounded-b-lg eightyvh cust-overflow-y-primary-color">
        <div
          class="items-center cursor-pointer pt-1"
          v-for="(item, index) in chapter"
          :key="'item -' + index"
        >
          <div
            v-b-toggle="'collapse-' + index"
            class="cardbody-p border-b-2 rounded-md mx-2 px-2 py-3"
          >
            <div class="flex w-full">
              <div class="flex width5">
                <feather-icon
                  icon="ChevronDownIcon"
                  class="cursor-pointer w-3 h-3"
                  v-if="!isCollapseVisible"
                ></feather-icon>
                <feather-icon
                  icon="ChevronUpIcon"
                  class="cursor-pointer w-3 h-3"
                  v-else
                ></feather-icon>
              </div>
              <div class="my-auto width55">
                <p
                  class="
                    font-semibold
                    text-md text-black
                    md:pl-6
                    lg:pl-4
                    pl-4
                    items-center
                  "
                >
                  {{ item.name }}
                </p>
              </div>
              <!-- <div class="width30 font-thin text-right pr-2 text-sm my-auto">
                00hr 15min
              </div> -->
            </div>
            <b-collapse :id="'collapse-' + index" class="bg-white mt-2 w-full">
              <div class="w-full items-center rounded-lg">
                <div
                  class="flex justify-between"
                  v-for="(items, index) in item.topic"
                  :key="'item -' + index"
                >
                  <div class="flex items-baseline py-2">
                    <div class="mr-2 ml-2 my-auto">
                      <!-- <feather-icon
                        icon="PlayCircleIcon"
                        class="cursor-pointer playicon-cust"
                      ></feather-icon> -->
                      <label class="custom-checkbox mb-0" id="allcheck">
                        <input type="checkbox" />
                        <span class="checkmark"></span>
                      </label>
                    </div>
                    <div
                      class="pl-2 flex flex-wrap items-center"
                      @click.stop="getTopic(items, item)"
                    >
                      <p class="font-semibold text-md pr-1">
                        {{ items.name }}
                      </p>
                      <div class="flex mt-1 items-center">
                        <feather-icon
                          v-if="items.docType == 'video'"
                          icon="PlayCircleIcon"
                          class="cursor-pointer playicon-cust mt-0"
                          svgClasses="w-4 h-4"
                        ></feather-icon>
                        <feather-icon
                          v-else-if="items.docType == 'pdf'"
                          icon="FileIcon"
                          class="cursor-pointer playicon-cust mt-0"
                          svgClasses="w-4 h-4"
                        ></feather-icon>
                        <p
                          class="font-thin ml-2 text-sm"
                          v-if="items.docType != 'pdf'"
                        >
                          {{ Math.floor(items.duration / 60 / 60) }}h{{
                            Math.floor(items.duration / 60) -
                            Math.floor(items.duration / 60 / 60) * 60
                          }}m{{ items.duration % 60 }}s
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <p
                  v-if="item.question.length != 0"
                  class="ml-5 font-semibold text-md pr-1"
                  @click.stop="getAssess(item)"
                >
                  Assessment
                </p>
                <div class="" v-if="item.embedded.length != 0">
                  <div
                    class="flex items-center px-6 py-3"
                    v-for="(emb, index) in item.embedded"
                    :key="index"
                  >
                    <div class="my-auto">
                      <feather-icon
                        icon="GlobeIcon"
                        class="font-semibold icon18px text-black"
                      >
                      </feather-icon>
                    </div>

                    <div
                      class="text-sm mx-3 my-auto font-medium"
                      @click="handleLink(emb)"
                    >
                      {{ emb.name }}
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      isCollapseVisible: false,
      courseChapter: [
        {
          chapter: "hello world programme",
        },
        {
          chapter: "print even Number",
        },
        {
          chapter: "Palindrome code",
        },
        {
          chapter: "odd number",
        },
      ],
      courseObject: [
        {
          name: "Course Introduction",
          chapters: [
            "hello world programme",
            "print even Number",
            "Palindrome code",
            "odd numbeee",
          ],
          showCollapse: false,
        },
        {
          name: "Python Setup",
          chapters: [
            "Course Introduction",
            " Why Python ?",
            "Course Curriculum Overview",
            "Course FAQs",
          ],
          // time: ["02.12", "03.25", "05.18", "10.08"],
          showCollapse: false,
        },
        {
          name: "Python Object and Data Structure Basics",
          chapters: [
            "Command Line Basics",
            " Running Python Code",
            "Getting the Notebooks and the Course Material",
            "Git and Github Overview (Optional)",
          ],
        },
        {
          name: "Python Statements",
          chapters: [
            "Numbers: Simple Arithmetic",
            " Variable Assignments",
            "Introduction to Strings",
            "Indexing and Slicing with Strings",
          ],
          showCollapse: false,
        },
        {
          name: "String Properties and Methods",
          chapters: [
            "Command Line Basics",
            " Running Python Code",
            "Getting the Notebooks and the Course Material",
            "Git and Github Overview (Optional)",
          ],
        },
        {
          name: "Lists in Python",
          chapters: [
            "Command Line Basics",
            " Running Python Code",
            "Getting the Notebooks and the Course Material",
            "Git and Github Overview (Optional)",
          ],
        },
        {
          name: "Dictionaries in Python",
        },
        {
          name: "Tuples with Python",
        },
        {
          name: "Booleans in Python",
        },
        {
          name: "Comparison Operators in Python",
        },
        {
          name: "Logical Operators",
        },
      ],
      chapter: [],
      studentId: "",
    };
  },
  props: {
    selectedCourse: Object,
  },
  methods: {
    async getStudent() {
      this.chapter = this.selectedCourse.chapter;
      // console.log(this.selectedCourse);
      const { data } = await this.$store.dispatch(
        "student/getStudentByUserId",
        {
          userId: this.userData._id,
        }
      );
      this.studentId = data[0]._id;
    },
    async getTopic(topics, chapters) {
      // console.log(topics);
      this.$store.commit("eLearning/SET_SELECTED_TOPIC", topics);
      if (topics.docType == "pdf") {
        const { data } = await this.$store.dispatch(
          "learningTracker/AddLearningData",
          {
            course: this.selectedCourse._id,
            student: this.studentId,
            topic: topics._id,
            chapter: chapters._id,
            status: "completed",
          }
        );
      } else {
        const { data } = await this.$store.dispatch(
          "learningTracker/AddLearningData",
          {
            course: this.selectedCourse._id,
            student: this.studentId,
            topic: topics._id,
            chapter: chapters._id,
            totalTime: parseInt(topics.duration),
            status: "in-progress",
          }
        );
      }
    },
    sortData() {
      if (!this.getTopic()) {
        this.$store.commit("eLearning/SET_SELECTED_TOPIC", {});
      } else {
        this.getTopic();
      }
    },
    async getAssess(chapter) {
      await this.$store.dispatch("eLearning/getAssessment", {
        chapter: chapter._id,
      });
    },
    async handleLink(linkdata) {
      if (linkdata.url.includes("http")) {
        window.open(linkdata.url, "_blank");
      } else {
        window.open("https://" + linkdata.url, "_blank");
      }
      const { data } = await this.$store.dispatch(
        "learningTracker/AddLearningData",
        {
          course: this.selectedCourse._id,
          student: this.studentId,
          topic: linkdata._id,
          chapter: linkdata.chapter,
          status: "completed",
        }
      );
    },
  },
  mounted() {
    this.getStudent();
  },
  computed: {
    ...mapState("auth", ["userData"]),
  },
};
</script>
